import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {CartService} from '../services/cart.service';
import {LanguageService} from '../services/language.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  order_id :any;
  order_amount:any;
  netpaid:any;
  order_date:any;
  payment_method:string; 
  userName:string;
  showLang:string;
  payMentMethod_ar:string;
  scheduleDate:string;

  constructor(private router:Router,
    private langObj:LanguageService,
    private srvcart:CartService){
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

    var orderDetails = JSON.parse(localStorage.getItem("order_details"));
    this.userName = localStorage.getItem("sajuname");
    if(orderDetails !=null){
      this.order_id = orderDetails['order_id'];
      this.order_amount = orderDetails['order_amt'];
      this.netpaid = orderDetails['netPaid'];
      this.order_date = orderDetails['order_date'];

      if (orderDetails['feastdata'] != 'NaN-NaN-NaN undefined'){
        this.scheduleDate = orderDetails['feastdata'];
      }
      
      if(orderDetails['payment_method'] == 'COD'){
        this.payment_method = "Cash on Delivery";
        this.payMentMethod_ar = "الدفع عند الاستلام";
      }else{
        this.payment_method = orderDetails['payment_method'];
      }
      this.srvcart.removeLocalStorage();
    }else{
      this.router.navigate(['/']);
    }
    
  }
}